export const policyTypes = {
    LOGIN_SIGNUP: 'B2C_1A_B2CSIGNUPORSIGNIN',
    P_UPDATE: 'B2C_1A_B2CPASSWORDCHANGE',
    EDIT_PROFILE: 'B2C_1A_B2CPROFILEEDIT',
}